import { useState } from "react";

const navItems = [
  { label: "入口索引", href: "#entries" },
  { label: "爆料合集", href: "#collections" },
  { label: "吃瓜速览", href: "#bites" },
  { label: "分类索引", href: "#categories" },
  { label: "访问说明", href: "#faq" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText("heiliao-direct.cc");
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-flashlight-fill text-base"></i>
            </span>
            <h1 className="font-heading text-lg md:text-xl font-bold tracking-tight text-foreground-950 whitespace-nowrap">
              黑料平台
              <span className="ml-2 hidden md:inline text-xs font-normal tracking-widest text-foreground-500">
                ENTRANCE NAV
              </span>
            </h1>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-600 rounded-md transition-colors hover:bg-background-100 hover:text-foreground-950 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleCopy}
              className="hidden sm:flex items-center gap-2 rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 whitespace-nowrap cursor-pointer"
            >
              <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
              {copied ? "已复制主入口" : "复制主入口"}
            </button>
            <button
              type="button"
              aria-label="展开菜单"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between py-3 text-sm text-foreground-700 border-b border-background-100 last:border-b-0 cursor-pointer"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}